import { onVerifyOCR } from 'e-submission/domain/service/ocr'

const ResultError = {
  status: 500,
  message: 'check real api response',
}

export const callAPIOCR = async (user, image, currentPayer) => {
  try {
    let resultAPI = await onVerifyOCR(user, image)
    let currentType = 'DCA' in currentPayer ? currentPayer.DCA : currentPayer.ATP

    if (resultAPI.statusCode == 200) {
      if ('DCA' in currentPayer) {
        if (currentType.accountName != resultAPI.accountName || currentType.accountNumber != resultAPI.accountNumber) {
          resultAPI.statusCode = 201
        }
      } else {
        if (
          currentType.accountName != resultAPI.bankBookNumber ||
          currentType.accountNumber != resultAPI.accountNumber
        ) {
          resultAPI.statusCode = 201
        }
      }
      if ('DCA' in currentType && currentType.bank.text != resultAPI.bankNameTH) {
        resultAPI.statusCode = 201
      }
      return { ...resultAPI, apptype: 'DCA' in currentPayer ? 'DCA' : 'ATP' }
    } else {
      return { ...resultAPI, apptype: 'DCA' in currentPayer ? 'DCA' : 'ATP' }
    }
  } catch (error) {
    console.error('callAPIOCR error: ', error)
    return { ...ResultError, apptype: 'DCA' in currentPayer ? 'DCA' : 'ATP' }
  }
}
